
export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img 
          src="https://public.readdy.ai/ai/img_res/c69222a08720b48554cad37dbf096d4b.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
        <div className="inline-block mb-6 px-6 py-2 bg-teal-400/90 rounded-full">
          <span className="text-sm font-semibold text-gray-900">VPN &amp; Cleaner Solutions</span>
        </div>
        
        <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold text-white mb-6 leading-tight">
          Premium iOS<br />Applications
        </h1>
        
        <p className="text-xl md:text-2xl text-gray-200 max-w-3xl mx-auto mb-12 leading-relaxed">
          Developing modern applications for the iOS platform that enhance user experience and improve mobile device security
        </p>

        <div className="mt-20">
          <div className="text-7xl md:text-8xl lg:text-9xl font-black text-white/20 tracking-wider">
            SECURITY FIRST
          </div>
        </div>
      </div>
    </section>
  );
}